<template>
<app-base-main style="padding-top: 8px;height: 100%; box-sizing: border-box;" :contentStyle="{'height': '100%'}">
  <template #base-content>
  <div class="box">
    <div class="layout">
      <div class="tabs-content">
        <span v-for="item in tabs"
              :key="item.id"
              :class="[tabsActive === item.id ? 'tabs--color' : 'color888']"
              style="margin-right: 20px;"
              class="tabs"
              @click="clickTabs(item.id)">
          {{item.text}}
        </span>
        <div class="tool-group">
          <gj-tool-group help></gj-tool-group>
        </div>
      </div>
      <div style="flex: 1; overflow: auto;" class="finance-profit-report">
        <div style="height: 100%;padding-top: 10px; box-sizing: border-box;">
          <template v-if="tabsActive === 'storageArgs'&&tabShow[0]">
            <app-storage-args></app-storage-args>
          </template>
          <template v-if="tabsActive === 'listingArgs'&&tabShow[1]">
            <app-listing-args></app-listing-args>
          </template>
          <template v-if="tabsActive === 'statisticsArgs'&&tabShow[2]">
            <app-statistics-args></app-statistics-args>
          </template>
          <template v-if="tabsActive === 'financeCost'&&tabShow[3]">
            <app-finance-cost></app-finance-cost>
          </template>
          <template v-if="tabsActive === 'businessConfig'">
            <app-business-config></app-business-config>
          </template>
          <template v-if="tabsActive === 'appCrmTask'">
            <app-crm-task></app-crm-task>
          </template>
          <template v-if="tabsActive === 'warningConfig'&&tabShow[4]">
            <app-waring-config></app-waring-config>
          </template>
          <template v-if="tabsActive === 'vatManage'&&tabShow[5]">
            <app-vat-manage></app-vat-manage>
          </template>
        </div>
      </div>
    </div>
  </div>
  </template>
</app-base-main>
</template>

<script>
  import AppStorageArgs from "./components/storage/storage-args";
  import AppListingArgs from "./components/listing/listing-args";
  import {isMeaningful} from "../../../../utils/common";
  import AppStatisticsArgs from "./components/statistics/statistics-args";
  import AppFinanceCost from "./components/finance/finance-cost";
  import AppBusinessConfig from "./components/business/business-config"
  import AppCrmTask from "./components/crm/crm-task"
  import AppWaringConfig from "./components/warning/warning-config"
  import AppVatManage from "./components/vat/vat-manage"
  import {userGuideMixin} from "../../../../minxins";
  import {mapGetters} from "vuex";

  export default {
    name: "app-argument",
    mixins: [userGuideMixin],
    components: {AppStatisticsArgs, AppListingArgs, AppStorageArgs, AppFinanceCost, AppBusinessConfig, AppWaringConfig, AppVatManage, AppCrmTask},
    data() {
      return {
        tabs: [],
        tabsActive: 'businessConfig',
        tabShow:[]
      }
    },
    activated() {
      if (isMeaningful(this.$route.query.activeTab)) {
        this.tabsActive = this.$route.query.activeTab;
      }
    },
    computed: {
      ...mapGetters(['userResources'])
    },
    watch:{
      userGuideState: {
      handler(val) {
        if(val) {
          this.tabActiveValue = 'financeCost'
        }
      }
      },
      userResources:{
        immediate: true,
        handler:function (n){
          this.tabs=[];
          this.tabShow=[
            this.$permission('inventoryIndex:edit'),
            this.$permission('listingSetting:edit'),
            this.$permission('globalParameter:edit'),
            this.$permission('financeAndCost:edit'),
            this.$permission('msgSetting:edit'),
            this.$permission('vatManage:edit')
          ]
          if(this.tabShow[0]){
            this.tabs.push({id: 'storageArgs', text: '库存指标设置'})
          }
          if(this.tabShow[1]){
            this.tabs.push({id: 'listingArgs', text: '商品设置'})
          }
          if(this.tabShow[2]){
            this.tabs.push({id: 'statisticsArgs', text: '统计指标设置'})
          }
          if(this.tabShow[3]){
            this.tabs.push({id: 'financeCost', text: '财务与成本'})
          }
          this.tabs.push({id: 'businessConfig', text: '业务配置'})
          this.tabs.push({id: 'appCrmTask', text: '售后任务'})

          if(this.tabShow[4]){
            this.tabs.push({id: 'warningConfig', text: '预警消息配置'})
          }

          if(this.tabShow[5]){
            this.tabs.push({id: 'vatManage', text: 'VAT管理'})
          }
          this.tabsActive = this.$route.query.activeTab || this.tabs[0].id
        }
      },
    },
    methods: {
      clickTabs(key) {
        this.tabsActive = key;
      }
    }
  }
</script>

<style lang="scss" scoped>
/deep/ .base-main{

}
.tool-group{
  position: absolute;
  top: -4px;
  right: 0px;
}
  .box {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #ffffff;
  }
  .tabs-content {
    border-bottom: 1px solid #e8e8e8;
    width: 100%;
    position: relative;
    margin-top: 6px;
    height: 29px;
  }
  .tabs {
    display: inline-block;
    text-align: center;
    padding-bottom: 4px;
    cursor: pointer;
    font-size: 14px;
    height: 27px;
    box-sizing: border-box;
  }
  .tabs + .tabs {
    margin-left: 25px;
  }
  .tabs--color {
    border-bottom: 2px solid #1F6EEF;
    color: #1F6EEF;
    font-size: 13px;
  }
  .color888 {
    color: #666;
  }
  /deep/ .table-shadow {
    box-shadow: unset;
  }
  .finance-profit-report /deep/ .el-table thead.is-group th {
    background: #ffffff;
  }
  /deep/ .operate-group{
    margin: 0;
  }
</style>
